import Book from './Book'
import { Easing } from '../helpers/EaseHelper'
import {
  getBookModelsPath,
  getBookMaterials,
  getBookCamera,
  getBookDuration
} from '../helpers/DataHelper'
import { createCamera, createScene3D, createObject3D } from '../helpers/3DEngineHelper'
import MotionCam from './MotionCam'
import { registerMaterial, replaceMeshMaterials } from '../helpers/MaterialHelper'

/**
 * class BookManager
 */
class BookManager {
  /**
   * constructor
   */
  constructor() {
    this.scene3D = createScene3D()
    this.camera = createCamera()
    this.container = createObject3D()
    this.scene3D.add(this.container)
    this.motionCam = new MotionCam(this.camera)
    this.book = null
  }

  loadBook (onProgress) {
    return new Promise ((resolve, reject) => {
      this.book = new Book()
      this.book.load(getBookModelsPath(), getBookMaterials(), onProgress)
      .then(book => {
        this.container.add(this.book.container)
        this.motionCam.setAnimation(getBookCamera(), getBookDuration())
        book.materials.map(registerMaterial)
        book.meshes.map(replaceMeshMaterials)
        resolve(book)
      })
    })
  }

  play () {
    this.container.scale.set(1, 1, 1)
    this.container.rotation.set(0, 0, 0)
    setTimeout(() => this.motionCam.playTween(), 1000)
  }

  openBook () {
    this.book.open()
    this.motionCam.playTweenRevert(1700, Easing.Cubic.InOut)
  }

  closeBook () {
    this.book.close()
    this.motionCam.playTween(() => {}, 1700, Easing.Quartic.InOut)
  }

  setSize (width, height) {
    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()
    if (this.book) this.book.setSize(width, height)
  }
}
export default BookManager


// WEBPACK FOOTER //
// ./src/scripts/webgl/BookManager.js